module.exports = __webpack_public_path__ + "img/thinktank-europa-logo.84f5095d.png";